<template lang="pug">
v-app
    v-app-bar( app dense dark color="deep-purple accent-4" )
      v-app-bar-nav-icon( @click.stop="drawer = !drawer" )
      span.ellipse.mr-header( v-if="hasNewAct || hasNewAgreement" )
      v-btn.mr-5( v-if="appBackLink" fab small text outlined :to="appBackLink" )
        v-icon mdi-keyboard-backspace
      v-toolbar-title
          template( v-if="appBarTitle == 'loading'" )
            v-progress-linear(indeterminate style="width:200px")
          template( v-else ) {{ appBarTitle }}
      div.offline-icon( v-if="offlineMode" @click="loadAllData")
        v-btn( fab small text outlined )
          v-icon mdi-access-point-network-off
        span.offline-mode Offline
      div.offline-icon( v-if="!offlineMode" )
        v-btn( fab small text outlined @click="loadAllData")
          v-icon mdi-access-point-network
        span.online-mode Online
    v-navigation-drawer( v-model="drawer" absolute temporary )
      v-list( nav dense )
        v-list-item-group( v-model="group" active-class="deep-purple--text text--accent-4" )
          v-list-item( v-for="(item,index) in menuItems" :key="index" :to="item.path" )
            v-list-item-icon
              v-icon {{ item.icon }}
            v-list-item-content
              v-list-item-title( v-text="item.name" )
            span.ellipse.mr-nav( v-if="item.name == 'Личный кабинет' && (hasNewAct || hasNewAgreement)" )
          v-list-item( @click="exit()" )
            v-list-item-icon
              v-icon mdi-logout
            v-list-item-content
              v-list-item-title Выход

    

    v-main(app)
      router-view
        
</template>



<script>
import { NavItems as items } from './nav/NavItems'
import { mapState, mapActions, mapMutations } from "vuex";
import { disconnectWebSocket } from '../_services/websocket';
import dataService from '../_services/dataService';
import syncService from '../_services/syncService';

export default {
  components: {
      
  },

  data: () => ({
    drawer:false,
    group: null
  }),

  mounted() {
    this.loadNotViewedMyAct()
    this.loadNotViewedMyAgreement()
  },  

  computed: {
    ...mapState(['appBarTitle','appBackLink']),
    ...mapState("act", ['notViewedMyAct']),
    ...mapState("agreement", ['notViewedMyAgreement']),
    ...mapState('user', ['offlineMode']),

    menuItems () {
      return items
    },

    hasNewAct() {
      return this.notViewedMyAct && this.notViewedMyAct.length
    },

    hasNewAgreement() {
      return this.notViewedMyAgreement && this.notViewedMyAgreement.length
    }
  },

  methods: {
    ...mapActions("authentication", ["logout"]),
    ...mapActions("act", ['loadNotViewedMyAct']),
    ...mapActions("agreement", ['loadNotViewedMyAgreement']),
    ...mapActions('user', ['changeMode']),
    ...mapMutations('pointreport', ['setLoadingReport']),

    exit() {
      this.logout()
      disconnectWebSocket()
    },

    async loadAllData() {
      if(this.offlineMode) {
        if(dataService.hasUnsyncedReport()) {
          await syncService.syncAll()
          localStorage.setItem('offlineMode', false)
          this.changeMode(false)
        }
      } else {
        this.setLoadingReport(true)
        await dataService.prefetchAll().finally(() => {
          this.setLoadingReport(false)
          localStorage.setItem('offlineMode', true)
          this.changeMode(true)
        })
      }
    },
  }
}
</script>
<style scoped>
.ellipse {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: #ED0E51;
  position: relative;
  background-image: url(/src/layouts/img/red-circle.gif);
  background-size: cover;
}
.mr-header {
  margin-left: -10px;
  margin-right: 10px;
  margin-bottom: 17px;
}
.mr-nav {
  margin-left: -5px;
  margin-bottom: 17px;
}
.offline-mode {
  color: red;
  margin-right: 10px;
  font-size: 20px;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
}
.online-mode {
  color: rgb(136, 255, 0);
  margin-left: 4px;
  margin-right: 10px;
  font-size: 20px;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
}
.offline-icon {
  margin-left: auto !important;
  display: flex;
  align-items: center;
}
</style>

